<!-- ConsultantLogin.vue -->
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            
            <!-- Left Side Image -->
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <!-- Right Side Form -->
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4 flex justify-between items-center">Consultant Portal <i18n /></h4>
                  <p>Welcome back! Please login to your consultant account.</p>
                </div>

                <!-- We only need one tab/form for consultants -->
                <div class="mt-6">
                  <consultant-login-jwt></consultant-login-jwt>
                </div>
                
                <!-- Link back to main login -->
                <div class="mt-8 text-center">
                  <router-link to="/user/auth/login" class="text-sm">Not a consultant? Go to Main Login</router-link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import ConsultantLoginJwt from "./ConsultantLoginJWT.vue";
import auth from '@/auth/authService';
import I18n from '@/layouts/components/navbar/components/I18n.vue';

export default {
  components: {
    ConsultantLoginJwt,
    I18n
  },
  mounted() {
    // Basic auth check
    if(this.$store.state.userAuth && this.$store.state.userAuth.isUserLoggedIn()){
      // If already logged in, push to consultant dashboard
      this.$router.push({name: 'consultant-dashboard'})
    }
  }
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;
}
</style>